

define(['angular', 'squid/index', 'components/xo-beaver/dist/logger', 'components/xo-models/src/checkout/index', 'components/xo-models/src/auth/index', 'components/xo-return-to-merchant/dist/util', './fallback', './contingency'], function (angular) {

    var ERROR_STATE;
    var ERROR_PREVENTED;

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.lib.error', ['squid', 'beaver', 'xomodel.checkout', 'xomodel.auth', 'xo-return-to-merchant', 'hermes.lib.fallback', 'hermes.lib.contingency']).run(function ($rootScope, $exceptionHandler, $logger) {

        function constructEventName(toState, fromState) {
            var from = fromState.name.replace(/\./g, '_') || 'start';
            var to = toState.name.replace(/\./g, '_') || 'end';

            return 'state_change_' + from + '_to_' + to;
        }

        var stateChangeError = $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
            // Set prevent default to avoid angular UI router to keep looping back to same state
            event.preventDefault();
            $exceptionHandler(err, constructEventName(toState, fromState));
        });

        $rootScope.$on('$destroy', stateChangeError);

        var windowError = $rootScope.$on('$windowError', function (event, details) {
            $logger.error('window_error', details, {
                debounceFactor: details.message,
                debounceInterval: 1000
            });
        });

        $rootScope.$on('$destroy', windowError);
    }).factory('$apiErrorHandler', function ($ApiError, $FallbackError, $logger) {
        return function (err) {
            if (err instanceof $ApiError) {
                $logger.error('api_error', {
                    error: err.toString()
                });

                throw new $FallbackError({
                    reason: 'api_error',
                    product: 'ux'
                });

                // @TODO - wtf?
                return true; // eslint-disable-line no-unreachable
            }
        };
    }).factory('$forbiddenHandler', function ($Forbidden, $logger, $AuthModel, $state, $FallbackError) {
        return function (err) {
            if (err instanceof $Forbidden) {
                $logger.warn('forbidden_handler');
                $AuthModel.instance().invalidate();

                throw new $FallbackError({
                    reason: 'user_not_logged_in',
                    product: 'ux'
                });

                // @TODO - throw, then return? uh what?
                return true; // eslint-disable-line no-unreachable
            }
        };
    }).factory('$exceptionHandler', function ($injector) {

        return function (err, cause) {
            return $injector.invoke(function ($util, $logger, $state, $Error, $FallbackError, $fallbackErrorHandler, $contingencyHandler, $forbiddenHandler, $rootScope, $window) {

                if (ERROR_STATE) {

                    if (ERROR_PREVENTED) {
                        throw err;
                    }

                    return;
                }

                // non token based Guest Upgrade Flow
                if ($util.param('data')) {
                    $logger.error('guest_upgrade_error', {
                        error: err
                    });
                    $state.go('guestupgrade.genericError', {
                        code: 'GUEST_UPGRADE_ERROR'
                    });
                    return;
                }

                var handlers = [{
                    type: '$FallbackError',
                    handle: $fallbackErrorHandler
                }, {
                    type: '$Contingency',
                    handle: $contingencyHandler
                }, {
                    type: '$Forbidden',
                    handle: $forbiddenHandler
                }];

                var handled = handlers.some(function (handler) {
                    if (err instanceof $injector.get(handler.type)) {
                        handler.handle(err);
                        return true;
                    }

                    return false;
                });

                if (handled) {
                    return;
                } else if (!err.transient) {
                    ERROR_STATE = err;
                }

                var errType = (err.constructor.name || 'error').toLowerCase();
                var errName = 'ui_unhandled_' + errType;
                var errMsg = err.message || '';

                if (errMsg.indexOf('infdig') > -1) {
                    errName = 'infinite_digest';
                } else if (errMsg.indexOf('inprog') > -1) {
                    errName = 'digest_inprog';
                } else if (errMsg.indexOf('badparse') > -1) {
                    errName = 'sanitize_badparse';
                } else if (errMsg.match(/^[\w_]+$/) && !(err instanceof $Error)) {
                    errName = errMsg;
                }

                if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
                    if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
                        errName = 'ui_unhandled_framework_error';
                    }
                }

                var errObj = {
                    error: err.stack || err.toString(),
                    message: errMsg,
                    cause: cause && cause.toString(),
                    state: $state.current.name,
                    url: $window.location.toString()
                };

                $logger.error(errName, errObj);

                // emit the error object for subscribers like xo-tracking
                var event = $rootScope.$emit('unhandled_error', {
                    route: ($state || {}).current,
                    message: errObj.error,
                    code: errObj.cause,
                    currentRoute: $state.current
                });

                if (event.defaultPrevented) {
                    ERROR_PREVENTED = true;
                    throw err;
                } else if (!err.transient) {
                    return $fallbackErrorHandler(new $FallbackError({
                        reason: errName
                    }));
                }
            });
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/error.js
// module id = ./js/lib/error.js
// module chunks = 1